import { useState } from 'react'
import { Generate_Student_Password } from '@graphql/mutations'
import { useApi } from '@hooks/useApi'

const useGenerateStudentPassword = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      { input: data },
      Generate_Student_Password,
      successMessage ? successMessage : 'Lösenordet skapades.',
      errorMessage ? errorMessage : 'Något gick fel. Försök igen och kontakta oss om felet kvarstår.'
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useGenerateStudentPassword }
